import {
  Row,
  Col,
  Divider,
  Avatar,
  Typography,
  Space,
  Dropdown,
  Form,
  Button,
} from "antd";
import ModalCustom from "../components/ModalCustom/ModalCustom";
import InputFields from "../components/InputFields/InputFields";
import { useRef } from "react";
import { FIELD_TYPE } from "../type/fileType";
import user from "../api/user";
import Notification from "../components/Notification";
import { useNavigate } from "react-router-dom";

const { INPUT } = FIELD_TYPE;

const HeaderMain = () => {
  const navigate = useNavigate();

  const openChangePasswordModal = useRef();
  const [formChangePassword] = Form.useForm();

  const handleChangePassword = async () => {
    // Implement change pastrysword logic here

    try {
      const values = formChangePassword.getFieldsValue();
      const username = localStorage.getItem("username");
      if (!username) {
        throw new Error("Không tìm thấy thông tin người dùng");
      }
      const data = {
        username: username,
        ...values,
      };
      await user.changePasswword(data);
      // Call API to change password with the values
      // const
      localStorage.clear();
      navigate("/login", { replace: true });
      Notification(
        "success",
        "Đổi mật khẩu thành công. Vui lòng đăng nhập lại.",
      );
    } catch (error) {
      Notification("error", "Đổi mật khẩu không thành công");
      console.error("Đổi mật khẩu không thành công:", error);
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <a
          onClick={() => {
            openChangePasswordModal.current.openModal();
          }}
        >
          Đổi mật khẩu
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <a
          onClick={() => {
            localStorage.clear();
            navigate("/login", { replace: true });
          }}
        >
          Đăng xuất
        </a>
      ),
    },
  ];

  const userName = localStorage.getItem("username");

  const dataFields = [
    {
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      labelCol: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
      wrapperCol: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
      type: INPUT,
      name: "password",
      label: "Mật khẩu hiện tại",
      rules: [{ required: true, message: "Chưa nhập mật khẩu hiện tại" }],
    },
    {
      type: INPUT,
      name: "newPassword",
      label: "Mật khẩu mới",
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      labelCol: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
      wrapperCol: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
      rules: [{ required: true, message: "Chưa nhập mật khẩu mới" }],
    },
  ];

  return (
    <div className="headerMain-container">
      <Row justify={"space-between"} align={"middle"}>
        <Col>
          <Space
            style={{ width: "100%", height: "100%" }}
            direction="horizontal"
            split={<Divider type="vertical" />}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Dropdown arrow={true} menu={{ items }} placement="bottom">
                <Avatar size="large" style={{ backgroundColor: "#CA5442" }}>
                  {userName?.toLocaleUpperCase().charAt(0)}
                </Avatar>
              </Dropdown>
              <Typography className="account-name">{userName}</Typography>
            </div>
          </Space>
        </Col>
      </Row>
      <ModalCustom
        className="change-password-modal"
        ref={openChangePasswordModal}
        title="Đổi mật khẩu"
        width={1000}
      >
        <Form form={formChangePassword}>
          <Space direction="vertical" size={"large"} style={{ width: "100%" }}>
            <Row gutter={[16, 8]}>
              <InputFields data={dataFields} />
            </Row>
            <Row justify={"end"}>
              <Button type="primary" onClick={handleChangePassword}>
                Đổi mật khẩu
              </Button>
            </Row>
          </Space>
        </Form>
      </ModalCustom>
    </div>
  );
};

export default HeaderMain;
